import { render, staticRenderFns } from "./DetailComponent.vue?vue&type=template&id=675bd3ce&"
import script from "./DetailComponent.vue?vue&type=script&lang=js&"
export * from "./DetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports